import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18.75 21H5.25C4.00804 20.9983 3.00165 19.992 3 18.75V5.25C3.00165 4.00804 4.00804 3.00165 5.25 3H18.75C19.992 3.00165 20.9983 4.00804 21 5.25V18.75C20.9983 19.992 19.992 20.9983 18.75 21ZM6.42 5.34C5.82376 5.34055 5.34055 5.82376 5.34 6.42V16.635C5.34055 17.2312 5.82376 17.7144 6.42 17.715H9.75C10.3462 17.7144 10.8294 17.2312 10.83 16.635V6.42C10.8294 5.82376 10.3462 5.34055 9.75 5.34H6.42ZM14.25 5.34C13.6538 5.34055 13.1706 5.82376 13.17 6.42V12.135C13.1706 12.7312 13.6538 13.2144 14.25 13.215H17.58C18.1762 13.2144 18.6594 12.7312 18.66 12.135V6.42C18.6594 5.82376 18.1762 5.34055 17.58 5.34H14.25Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Trello"
);
